module.exports = {
  pleaseWait: 'Please wait',
  loading: 'loading',
  Billing: 'Purchases',
  billingTips: 'Your Purchased History',
  ID: 'ID',
  FAQ: 'FAQ',
  TC: 'T&C',
  Copyright: '© 2026 All Rights Reserved.',
  GenerateImage: 'Generate Image',
  generateTips1: 'Our AI image generator brings imagination to life, producing stunning art, illustrations, and photos in seconds. Unleash creativity and express yourself in new ways with the power of AI. Explore endless possibilities, from crafting unique marketing materials to creating beautiful artwork, all with supreme ease and efficiency.',
  generateTips2: 'Enter a few words below, and watch SnapAI transform text into incredible art.',
  Prompt: 'Prompt',
  PromptTips1: 'Tell AI what to create.',
  PromptTips2: 'Tips: describe mood and lighting. See page tips for more.',
  PromptTips3: 'Note: AI may not follow instructions and it cannot count.',
  Generate: 'Generate',
  ChancesLeft: 'Chances Left',
  BuyChances: 'Buy More Chances',
  generateImageTips1: 'Input what you want',
  generatePromptsTips1: 'Input what you don\'t want',
  indexTips1: 'Daily Free Chance <br /> Available!',
  indexTips2: 'Choose one of the functions',
  ImageRestorer: 'Image Restorer',
  Continue: 'Continue',
  language0: 'Language',
  language: 'Choose language',
  languageTips: 'Choose your language here',
  Submit: 'Submit',
  change: 'Save',
  lang_1: 'English',
  lang_2: 'Русский',
  lang_3: "O'zbekcha",
  Login: 'Login',
  Logout: 'Log out',
  getCode: 'Resend',
  loginTips: 'Enter a phone number',
  profile: 'Profile',
  phoneNumber: 'Phone number',
  SubscribedSince: 'Subscribed since',
  RemainingChances: 'Remaining chances',
  cgtips2: 'Only 1500 sum/daily,<br />please click OK to subscribe.',
  OK: 'OK',
  PictureRestorer: 'Picture Restorer',
  PictureTips1: 'Restore, sharpen, and repair pictures with AI. SnapAI builds on the latest research to automatically remove scratches, sharpen colors, and enhance faces, transforming damaged photos into cherished memories. Our free service repairs both color photos and black & white ones.',
  Upload: 'Upload',
  PictureTips2: 'Has a scratch?',
  Restore: 'Restore',
  uploadTips: 'Please upload pictures',
  History: 'History',
  purchaseTips1: 'Total chances left',
  Daily: 'Daily',
  Purchase: 'Purchase',
  DailyKyats: '1500 sum',
  Subscribe: 'Subscribe',
  BuyNow: 'Buy Now',
  logout: 'Logout',
  petTitle1: 'AI Anime Pets',
  petTitle2: 'Choose Style',
  petContent1: 'Transforms your beloved pet’s photos into a whimsical, anime-style masterpiece. Perfect for pet lovers and anime enthusiasts, SnapAI offers a fun and personalized way to celebrate your furry friends.',
  sexTitle1: 'AI Anime Selfie',
  sexTitle2: 'Choose Gender',
  sexContent1: 'Brings your imagination to life by generating anime-style photos based on written prompts. Whether you\'re a fan of anime, a storyteller, or a designer, AI Anime Selfie empowers you to create vibrant, high-quality anime-style visuals effortlessly, blending advanced AI with your unique vision.',
  sexContent2: 'Choose a style below and watch SnapAI transform text into incredible art.',
  Female: 'Female',
  Male: 'Male',
  Style1: 'Style 1',
  Style2: 'Style 2',
  Style3: 'Style 3',
  Comic: 'Comic',
  Disney: 'Disney',
  Ghibli: 'Ghibli',
  Animalanime: 'Selfie Anime',
  HumanAnime: 'Human Anime',
  Guidance: 'Guidance',
  PetAnime: 'Pet Anime',
  landTips1: 'Generate Stunning Photos &',
  landTips2: 'WIN BIG PRIZES!',
  landTips3: 'Transform your imagination into reality with SnapAI! From stunning photo generation to artistic masterpieces, SnapAI empowers you to create visuals like never before. Dive into a world of limitless possibilities.',
  show401tip: 'Balance not enough',
  show400dailytip: 'Time out, please send "AID" to 88800 to win the big prize.',
  register: 'Register',
  invitation: 'Invite a friend',
  invitationTips: 'Copy and send invite using the link below',
  InviteNow: 'Invite',
  copySuccess: 'Copy Success!',
  CopySucceeded: 'Copy Success!',
  process: 'Generating',
  downTips1: 'Please copy the link into the browser and download.',
  copyLink: 'Copy link',
  free: 'Free',
  aiAnimeTitle: 'AI Couples Anime',
  aiAnimeCt1: 'Transform your original couple photos into anime-style images, making your romantic memories even more fun. Whether you\'re an anime enthusiast or a designer, AI Anime Photo allows you to effortlessly create meaningful and high-quality anime-style visuals, perfectly blending advanced AI technology with your romantic moments. ',
  aiAnimeCt2: 'Select the style below and upload your original photo to watch SnapAI transform your sweet memories into stunning artworks.',
  comingsoonT: 'coming soon',
  SubscribePackage: 'Subscribe Package',
  landfont1: 'Turn photo into stunning anime artwork.',
  landfont2: 'Transform your couple photos into beautiful anime characters.',
  landfont3: 'Write a prompt to generate beautiful images',
  landfont4: 'Turn your pets into adorable anime characters with AI magic!',
  landfont5: 'Rediscover your memories with AI-powered photo restoration.',
  SmartCutout: 'Smart Cutout',
  letgo: 'Let\'s Go',
  IpIMage: 'ID Photo',
  IpIMageTip: 'Need a license or ID photo created? We\'ve got you covered!',
  IpIMage_content: 'The original image uploaded for the ID photo must ensure that the face of the person is clear, without any obstruction (hair, glasses, etc.), and the shoulders are on the same level. Otherwise, the generation may fail. ',
  snapbot: 'SnapBot',
  snapbot_hi: 'Hi, I\'m SnapBot.',
  help_today: 'How can I help you today?',
  think_ip: '🤖 Thinking...',
  Coloring_old_photos: 'Image Recolor',
  Coloring_old_photos_tips: 'Bring your memories back to life by restoring color\n' +
    'in your vintage photos. Our AI-powered tool\n' +
    'automatically analyzes and adds natural color tones,\n' +
    'preserving the charm of the original while\n' +
    'enhancing its visual appeal.\n',
  Coloring_old_photos_tips2: 'Bring your old photos to life with AI-powered color restoration.',
  BgFusion: 'Smart Blend',
  BgFusion_tips2: 'Customize your photo with a background of your choice',
  BgFusion_tips: 'Customize your photo with a background of your choice.\n' +
    'Our smart AI replaces the original background\n' +
    'and blends your image naturally into the new one',
  Upload_bg: 'Upload Background',
  Upload_pt: 'Upload Portrait',
  Recolor: 'Recolor',
  snapbotTips1: 'Fast Search Results',
  snapbotTips2: 'Natural Language processing',
  snapbotTips3: 'Big Data Analysis',
  snapbotTips4: 'AI-powered Algorithms',
  snapbotInput1: 'Tap here to start chatting with SnapBot',
  white: 'white',
  blue: 'blue',
  '1 inch': '35×45',
  '2 inches': '50×50',
  landTips11: 'Create Awesome Photos &',
  ChangeHairstyle: 'Hairstyle Magic',
  ChangeHairstyle_short: 'Create and try out your Imagined Hairstyles',
  ChangeHairstyle_content_1: 'SnapAI offers a feature for changing hairstyles, allowing users to try on different haircuts in real-time or via uploaded photos. This feature leverages AI technology to analyze the user\'s facial features and suggest hairstyles that suit their face shape, preferences, and style. Users can experiment with various looks, ranging from subtle changes to bold, dramatic transformations, giving them a virtual preview before committing to an actual change.',
  ChangeHairstyle_content_2: 'Choose your favorite hairstyle below and add your own photo.',
  Result: 'Result',
  Original: 'Original',
  unsub_tip: 'To unsubscribe, send OFF AID to 88800',
  sub_tip: 'To subscribe, send "AID" to 88800',
  longHairEffects: 'Long Hair Effect',
  longHairEffects_tip: 'Experience the Long Hair Effect for a naturally attractive hairstyle. This feature effortlessly adds the appearance of longer hair, enhancing your look.\n' +
    'Smooth & Shiny\n' +
    'Natural-looking length\n' +
    'Perfect for any outfit, Look your best every day with the Long Hair Effect!',
  VIDEO: 'VIDEO',
  style: 'style',
  pic_size_limit :"Images cannot exceed 5MB",
  login_tip:"By clicking the «Get SMS-code» button, you are subscribing to access the service on the website <a href='https://mobiuz.snapai.asia' style='text-decoration: underline;color: white'>https://mobiuz.snapai.asia</a>, confirming that you are already 18 years old, and that you have read and agreed to the terms of service outlined in the <a href='/#/termsAndCondition' style='text-decoration: underline;color: white'>User Agreement</a>. The subscription cost is 1500 UZS per day (including VAT).",
  Trending:'Trending',
  Face_Magic:'Face Magic',
  AI_Studio:'AI Studio',
  Home:'Home',
  unsubscribe:'Unsubscribe',
  Back:'Back',
  Chances:'Chances',
  Setting:'Settings',
  Menu:'Menu',
  New:'New',
  image_max_size:"File size exceeds 5MB",
  file_max_size:"File size exceeds 1MB",
  new_chat:"New Chat",
  file:"File",
  image:"Image",
  invalid_image_format:"invalid file format",
  Shoot_same_video:"Create a video",
  aiVividScene:"Vivid AI Scene",
  aiVividScene_desc:"Capture the perfect photo for any mood or season with the new AI Scene Creator! Just upload a clear photo of your face, and instantly explore various backgrounds, styles, and color tones. Transport yourself to a summer beach, a vibrant cityscape, a rainy street, or any fantasy world—no travel needed!",
  image_video:'Image to Video',
  image_video_tip:'This feature transforms a still photo into a 1–3 minute animated video, adding natural facial expressions and movements to bring the image to life. Users can also revisit previously generated videos from the history tab.',
  image_video_input:"Describe the style and appearance of the photo you want to create.",
  word_video:'Word to Video',
  word_video_tip:'This feature transforms your written text into a dynamic, lifelike video using AI technology, capturing your desired style and expression. Video generation may take 1–3 minutes, and you can review previously created videos in the history tab.',
  word_video_input:"Describe the style and appearance of the video you want to create.",
  get_sms_code:"Get SMS-code",

}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js